import { Moon, Sun } from "lucide-react";
import { useColorScheme } from "@mui/joy/styles";

/**
 * Dark/light switch, sized to sit in the time sidebar header beside the
 * wordmark. `mode` is undefined until Joy has mounted and resolved the stored
 * scheme, so nothing renders until then rather than flashing the wrong icon.
 */
export default function ThemeToggle() {
  const { mode, systemMode, setMode } = useColorScheme();

  if (!mode) {
    return null;
  }

  const isDark = (mode === "system" ? systemMode : mode) === "dark";

  return (
    <button
      type="button"
      onClick={() => setMode(isDark ? "light" : "dark")}
      title={isDark ? "Light mode" : "Dark mode"}
      className="ml-auto flex h-7 w-7 items-center justify-center rounded-md text-muted-foreground hover:bg-sidebar-accent hover:text-sidebar-accent-foreground cursor-pointer"
    >
      {isDark ? <Sun className="size-4" /> : <Moon className="size-4" />}
      <span className="sr-only">
        {isDark ? "Switch to light mode" : "Switch to dark mode"}
      </span>
    </button>
  );
}
